import React, { ReactNode } from "react";
import Tooltip from "./Tooltip";
import { TooltipProps } from "@chakra-ui/react";

type ConditionalTooltipProps = Omit<TooltipProps, "children" | "label"> & {
  enabled?: boolean;
  label?: ReactNode;
  children: ReactNode;
  /**
   * When true, forces wrapping children so non-text nodes receive hover events consistently.
   * Defaults to Tooltip's own shouldWrapChildren behavior if not provided.
   */
  forceWrapChildren?: boolean;
};

const ConditionalTooltip: React.FC<ConditionalTooltipProps> = ({
  enabled = true,
  label,
  children,
  forceWrapChildren,
  ...tooltipProps
}) => {
  if (!enabled || !label) {
    return <>{children}</>; // no-op when disabled or no content
  }

  return (
    <Tooltip
      label={label}
      shouldWrapChildren={forceWrapChildren ?? tooltipProps.shouldWrapChildren}
      {...tooltipProps}
    >
      {children}
    </Tooltip>
  );
};

export default ConditionalTooltip;


